// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type PhoneNumber } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useAddToolToPhoneNumber(): (
  phoneNumberId: string,
  toolId: string
) => Promise<PhoneNumber> {
  const getAPI = useGetApi();
  return useCallback(
    async (phoneNumberId, toolId) =>
      (await getAPI()).phonenumbers.addToolToPhoneNumber({
        phoneNumberId,
        toolId,
      }),
    [getAPI]
  );
}
